import { c as _c } from "react/compiler-runtime";
import type { DetailedHTMLProps, HTMLAttributes, ReactNode } from 'react';
import { Typography } from '@/components/Typography';
import { cn } from '@/lib/cn';
export interface CardActionTitleBarProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  leftAction?: ReactNode;
  rightAction?: ReactNode;
}
export function CardActionTitleBar(t0) {
  const $ = _c(16);
  const {
    className,
    children,
    leftAction,
    rightAction
  } = t0;
  const centerTitle = leftAction && rightAction;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex justify-between items-center px-6 pt-5 h-11", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== leftAction) {
    t2 = leftAction ? <div className="basis-6">{leftAction}</div> : null;
    $[2] = leftAction;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== centerTitle) {
    t3 = cn("flex-1 whitespace-nowrap text-center lg:text-start", {
      "text-center": centerTitle
    });
    $[4] = centerTitle;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== children || $[7] !== t3) {
    t4 = <Typography variant="h6" as="div" className={t3}>{children}</Typography>;
    $[6] = children;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== rightAction) {
    t5 = rightAction ? <div className="basis-6">{rightAction}</div> : null;
    $[9] = rightAction;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t4 || $[14] !== t5) {
    t6 = <div className={t1}>{t2}{t4}{t5}</div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}